import Vue from 'vue';
import router from '../../../src/router';
import store from '../../../src/store'
import bus from '../../../static/js/bus.js';
import VueResource from 'vue-resource';
import {
	Loading,
	Message
} from 'element-ui';
import NProgress from 'nprogress' //进度条
import 'nprogress/nprogress.css'
// 规则检验
import test from '../function/test.js'
import RSA from '../function/RSA.js'
import guid from '../function/guid.js'
import timeFormat from '../function/timeFormat.js'
import timeFrom from '../function/timeFrom.js'
import deidentification from '../function/deidentification.js' //去标识化
import trim from '../function/trim.js' //去标识化
import debounce from '../function/debounce.js'
import gkQSS from '../function/gkQSS.js'
import gdQSS from '../function/gdQSS.js'
import seeImage from '../function/seeImage.js'
import throttle from '../function/throttle.js'
import file from '../function/file.js'
import ui from '../function/ui.js'
import base64 from '../function/base64.js'
import stringFindDiff from '../function/stringFindDiff.js'
import {
	createLine,
	clearLine
} from '../function/createLine.js'
import imgUtl from '../function/image2Base64.js'
import getDay from '../function/FormatTime.js'
import lzurl from '../function/url.js'
import bookmark from '../function/bookmark.js'
import wps from '../function/wps.js'
import str from '../function/str.js'

import '../function/lizhaoHas.js'
import '../function/dialogDrag.js'

NProgress.configure({
	easing: 'ease', // 动画方式
	speed: 500, // 递增进度条的速度
	showSpinner: false, // 是否显示加载ico
	trickleSpeed: 200, // 自动递增间隔
	minimum: 0.3, // 初始化时的最小百分比
})

Vue.use(VueResource)
let host = window.location.href.match(/((.*?)\/\/(.*?))\//)[1]
let service_url = process.env.NODE_ENV === 'development' ? '/apis' : (host + '/stamper/apis')

//获取配置文件
async function startApp(type) {
	let data = await Vue.http.get('./static/config.json') //此路径是相对于服务器的路径
	if (type === 'MAP_CITY_URL') {
		return JSON.parse(data.bodyText)[type]
	}
}

let service_Img = ""; //浪潮图片前缀
async function doGet(url, req, successCallback, errorCallback) {
	return new Promise((resolt, rejcet) => {
		req = filterUndefined(req)
		let urlArr = [
			'/electronic/enterprise/application/findAuthorized',
			'/auth/notice/getDisassemblyRecordInfoList',
			'/third/jumpLink/findApplicationIds',
			'/third/jumpLink/findDeptTreeList',
			'/third/jumpLink/findApplicationInfo',
			'/auth/notice/alarm'
		]
		if (urlArr.includes(url) || url.indexOf('/system/logger/downloadBack') == 0) {

		} else {
			// 每次切换页面时，调用进度条
			NProgress.start();
		}
		const resultUrl = url.includes('http:' || 'https:') ?
			url :
			service_url + url
		Vue.http.get(resultUrl, {
			params: {
				...req,
				_tenant: store.state.user.roterOrgId
			}
		}, {
			emulateJSON: true, //允许跨越
			headers: {
				'Content-Type': 'application/json;charset=UTF-8'
			}
		}).then(function (response) {
			if (response.headers.map['accept-ranges']) {
				response.data = {
					data: response.data,
					bytes: response.headers.map['accept-ranges'],
				}
			}
			if ((response.data.code < 700 && response.data.code > 600) || response.data.code ===
				600) {
				//清除定时器拆章
				bus.$emit('checkOut');
				localStorage.removeItem('userInfo')
				if (response.data.code == 601) {
					router.replace({
						path: `/${response.data.data.domain}/login`
					})
					return
				}
				router.replace({
					path: `/${store.state.user.roterOrgId}/login`
				})
			}
			if (response.data.code && response.data.code !== 200 && req.showToast != false) {
				Message.warning(response.data.msg)
			}
			// 在即将进入新的页面组件前，关闭掉进度条
			NProgress.done()
			// 响应成功回调
			successCallback && successCallback(response.data);
			resolt(response.data)
		}, function (error) {
			// 在即将进入新的页面组件前，关闭掉进度条
			NProgress.done()
			// 响应错误回调
			errorCallback && errorCallback(error)
			rejcet(error)
		});
	})
}

async function doDelete(url, req, successCallback, errorCallback) {
	req = filterUndefined(req)
	// 每次切换页面时，调用进度条
	NProgress.start();

	Vue.http.delete(service_url + url, {
		params: req,
		_tenant: store.state.user.roterOrgId
	}, {
		emulateJSON: true, //允许跨越
	}).then(function (response) {
		// 在即将进入新的页面组件前，关闭掉进度条
		NProgress.done()
		// 响应成功回调
		successCallback && successCallback(response.data);
	}, function (error) {
		// 在即将进入新的页面组件前，关闭掉进度条
		NProgress.done()
		// 响应错误回调
		errorCallback && errorCallback(error)
	});
}


async function doPost(url, req, successCallback, progressCallback) {
	req = filterUndefined(req)
	let onoff = false
	try {
		//全局配置需要量子传输的接口
		let quantumApis = JSON.parse(localStorage.getItem('qssList'))
		onoff = quantumApis.includes(url)
	} catch (e) {
		//TODO handle the exception
	}

	//判断是否需要量子加密
	if (onoff) { //需要加密
		QuantumDoPost(url, req, successCallback)
	} else { //无需加密正常请求
		NotQuantumDoPost(url, req, successCallback, progressCallback)
	}
}

//无量子加密请求
async function NotQuantumDoPost(url, req, successCallback, progressCallback) {
	//菊花
	let loadingInstance = ""
	if (req.keyword || req.keyword === '' || url === '/auth/notice/getDisassemblyRecordInfoList') {

	} else {
		// 每次切换页面时，调用进度条
		NProgress.start();
	}
	try {
		req.append('_tenant', store.state.user.roterOrgId)
	} catch (e) {
		//TODO handle the exception
		if (req) {
			req._tenant = store.state.user.roterOrgId
		} else {
			req = {
				_tenant: store.state.user.roterOrgId
			}
		}

	}
	console.log('url', url);
	const resultUrl = url.includes('http:' || 'https:') || url[0] !== '/' ?
		url :
		service_url + url
	Vue.http.post(resultUrl, req, {
		emulateJSON: req.emulateJSON == false ? false : true, //允许跨越
		headers: {
			'Content-Type': 'application/json;charset=UTF-8'
		}
		// progress:(e)=>{//上传进度条回调
		// 	if(e.lengthComputable){
		// 		let value=Math.round(e.loaded * 100 / e.total)
		// 		progressCallback(value)
		// 	}
		// }
	}).then(function (response) {
		//关闭菊花
		try {
			if (req.keyword || req.keyword === '' || url === '/auth/notice/getDisassemblyRecordInfoList') {

			} else {
				// 在即将进入新的页面组件前，关闭掉进度条
				NProgress.done()
			}
		} catch (e) {
			//TODO handle the exception
		}
		if (response.data.encryption) { //需要解密
			let dataReq = {
				encContentss: response.data.data,
				tickets: response.data.ticket,
				msg: response.data.msg
			}
			QuantumDecrypt(dataReq, successCallback)
		} else { //不需要解密正常返回
			//大于600跳登录
			if ((response.data.code < 700 && response.data.code > 600) || response.data.code === 600) {
				//清除定时器拆章
				bus.$emit('checkOut');
				Message.warning(response.data.msg)
				localStorage.removeItem('userInfo')
				// 在即将进入新的页面组件前，关闭掉进度条
				NProgress.done()
				if (response.data.code == 601) {
					router.replace({
						path: `/${response.data.data.domain}/login`
					})
					return
				}
				router.replace({
					path: `/${store.state.user.roterOrgId}/login`
				})
			}
			if (response.data.code !== 200) {
				Message.warning(response.data.msg)
			}
			if (response.data.code === 599) {
				router.push({
					path: '/' + store.state.user.roterOrgId + '/myInfo'
				})
			}
			// 响应成功回调
			successCallback && successCallback(response.data);
		}

	}, function (error) {
		// 在即将进入新的页面组件前，关闭掉进度条
		NProgress.done()
	});
}

// //量子加密
async function QuantumDoPost(url, req, successCallback) {
	//菊花
	let loadingInstance = ""
	loadingInstance = Loading.service({
		lock: true,
		text: '量子加密传输中....',
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0, 0.7)'
	});
	//114.214.164.77  114.214.170.194
	Vue.http.post('http://127.0.0.1:2222/crptorgraphy', {
		msg: JSON.stringify(req)
	}, {
		emulateJSON: true,
		_timeout: 3000,
		onTimeout: function (request) {
			//超出时间你要处理的逻辑
			Vue.prototype.$confirm('未检测到量子设备，是否进行无量子加密传输？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				NotQuantumDoPost(url, req, successCallback, progressCallback)
			}).catch(function () { });
		}
	}).then(function (response) {
		console.log('量子加密成功：', response.data)
		let res = response.data
		//关闭菊花
		try {
			loadingInstance.close();
		} catch (e) {
			//TODO handle the exception
		}
		let dataReq = {
			content_quantum: res.encmsg,
			ticket: res.tickets,
			sessionkeyid: res.sessionkeyid,
		}
		NotQuantumDoPost(url, dataReq, successCallback, progressCallback)
	}, function (error) {
		//关闭菊花
		try {
			loadingInstance.close();
		} catch (e) {
			//TODO handle the exception
		}
	});
}

// //解密
function QuantumDecrypt(req, successCallback) {
	//菊花
	let loadingInstance = ""
	loadingInstance = Loading.service({
		lock: true,
		text: '量子加密传输中....',
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0, 0.7)'
	});
	Vue.http.post('http://127.0.0.1:2222/decrpy', req, {
		emulateJSON: true
	}).then(function (response) {

		//关闭菊花
		try {
			loadingInstance.close();
		} catch (e) {
			//TODO handle the exception
		}
		if (response.data.flag) {
			let data = {
				data: JSON.parse(response.data.msg),
				code: 200,
				msg: req.msg
			}
			successCallback && successCallback(data)
		} else {
			Message.warning(response.data.msg)
		}
	}, function (error) {
		Message.warning('未检测到量子设备，无法进行解密')
		//关闭菊花
		try {
			loadingInstance.close();
		} catch (e) {
			//TODO handle the exception
		}
	});
}

// //限制上传文件格式第一个传上传文件名，第二个限制类型
function restrictFormatUploaded(name, types) {
	let mun = name.indexOf('.')
	let sliceName = name.slice(mun, name.length)
	// let filetypes =["jpg","jpeg","png","rar","txt","zip","doc","ppt","xls","pdf","docx","xlsx","JPG","JPEG","PNG","RAR","TXT","ZIP","DOC","PPT","XLS","PDF","DOCX","XLSX"];
	let filetypes = types
	let arr = filetypes.filter(function (res) {
		if (sliceName.includes(res)) {
			return res;
		}
	})
	let onoff = false
	if (arr.length > 0) {
		onoff = true
	} else {
		onoff = false
	}
	return onoff;
}

// //获取时间
function getBeforeDate(n) { //n为你要传入的参数，当前为0，前一天为-1，后一天为1
	let date = new Date();
	let year, month, day, s;
	date.setDate(date.getDate() + n);
	year = date.getFullYear();
	month = date.getMonth() + 1;
	day = date.getDate();
	s = year + '/' + (month < 10 ? ('0' + month) : month) + '/' + (day < 10 ? ('0' + day) : day);
	return s;
}

//天翼云文件上传
function oosPutObject(req, successCallback, errorCallback) {
	console.log(req)
	let client = new OOS.S3({
		accessKeyId: 'd48e5428a82a6c67c3d4', //通过天翼云控制台创建的 access key
		secretAccessKey: '6dbc8f1ada9e1c9bc8812ff02611ea78c9531b51', // 通过天翼云控制台创建的 secret access key;
		endpoint: 'http://oos-cn.ctyunapi.cn', //OOS 域名
		signatureVersion: 'v4', // 可选v2 或v4
		apiVersion: '2006-03-01', //默认值
		s3ForcePathStyle: true //默认值
	});
	let params = {
		Bucket: req.Bucket,
		/*用户 bucket 名称*/
		Key: req.Key,
		/* 文件名  */
		Body: req.Body //文件
	};
	client.putObject(params, function (err, data) {
		if (err) {
			Message.warning('文件上传失败：' + err)
			errorCallback(err)
		} else {
			let successReq = {
				bucketName: req.Bucket,
				secretKey: req.secretKey,
				fileName: req.Key
			}
			successCallback(successReq) //返回加密秘钥
		}
	});
}

//天翼云文件下载
// req参数说明
// let params = {
// 		Bucket: newData.bucketName, /*用户 bucket 名称*/
// 		Key: newData.fileName, /* 文件名  */
// 		secretKey:newData.secretKey,//aes解密秘钥
// };
function oosGetObject(req, successCallback, errorCallback) {
	console.log('天翼云文件下载', req)
	let client = new OOS.S3({
		accessKeyId: 'd48e5428a82a6c67c3d4', //通过天翼云控制台创建的 access key
		secretAccessKey: '6dbc8f1ada9e1c9bc8812ff02611ea78c9531b51', // 通过天翼云控制台创建的 secret access key;
		endpoint: 'http://oos-cn.ctyunapi.cn', //OOS 域名
		signatureVersion: 'v4', // 可选v2 或v4
		apiVersion: '2006-03-01', //默认值
		s3ForcePathStyle: true //默认值
	});
	let params = {
		Bucket: req.Bucket,
		/*用户 bucket 名称*/
		Key: req.Key,
		/* 文件名  */
	};
	client.getObject(params, function (err, data) {
		if (err) {
			console.log('天翼云文件下载失败')
			errorCallback(err)
		} else {
			//把uint8Array转String
			let dataStr = Uint8ArrayToString(data.Body)
			//aes解密
			let newData = ''
			if (Vue.prototype.AES.DecryptECB(dataStr, req.secretKey).includes('data:image')) {
				newData = Vue.prototype.AES.DecryptECB(dataStr, req.secretKey)
			} else {
				newData = 'data:image/png;base64,' + Vue.prototype.AES.DecryptECB(dataStr, req.secretKey)
			}
			successCallback(newData)
		}
	});
}

//uint8Array转String
function Uint8ArrayToString(fileData) {
	var dataString = "";
	for (var i = 0; i < fileData.length; i++) {
		dataString += String.fromCharCode(fileData[i]);
	}
	return dataString
}

//字符串转Uint8Array
function stringToUint8Array(str) {
	var arr = [];
	for (var i = 0, j = str.length; i < j; ++i) {
		arr.push(str.charCodeAt(i));
	}
	var tmpUint8Array = new Uint8Array(arr);
	return tmpUint8Array
}

//过滤传参中的undefined
function filterUndefined(req) {
	let {
		keys,
		values,
		entries
	} = Object
	for (let [keys, values] of entries(req)) {
		if (values === undefined) {
			req[keys] = ''
		}
	}
	try {
		req = JSON.parse(req)
	} catch (e) {
		//TODO handle the exception
	}
	return req
}

//获取字符串第几次出现的位置
function stringFind(str, cha, num) {
	var x = str.indexOf(cha);
	for (var i = 0; i < num; i++) {
		x = str.indexOf(cha, x + 1);
	}
	return x;
}
//附件上传
async function doUpload(url, req, successCallback, progressCallback) {
	req = filterUndefined(req)
	let onoff = false
	try {
		//全局配置需要量子传输的接口
		let quantumApis = JSON.parse(localStorage.getItem('qssList'))
		onoff = quantumApis.includes(url)
	} catch (e) {
		//TODO handle the exception
	}

	//判断是否需要量子加密
	if (onoff) { //需要加密
		QuantumDoPost(url, req, successCallback)
	} else { //无需加密正常请求
		//菊花
		let loadingInstance = ""
		if (req.keyword || req.keyword === '' || url === '/auth/notice/getDisassemblyRecordInfoList') {

		} else {
			// 每次切换页面时，调用进度条
			NProgress.start();
		}
		req.append('_tenant', store.state.user.roterOrgId)
		Vue.http.post(service_url + url, req, {
			emulateJSON: req.emulateJSON == false ? false : true, //允许跨越
			headers: {
				'Content-Type': 'multipart/form-data'
			},
			progress: (e) => {//上传进度条回调
				if (e.lengthComputable) {
					let value = Math.round(e.loaded * 100 / e.total)
					progressCallback(value)
				}
			}
		}).then(function (response) {
			//关闭菊花
			try {
				if (req.keyword || req.keyword === '' || url ===
					'/auth/notice/getDisassemblyRecordInfoList') {

				} else {
					// 在即将进入新的页面组件前，关闭掉进度条
					NProgress.done()
				}
			} catch (e) {
				//TODO handle the exception
			}
			if (response.data.encryption) { //需要解密
				let dataReq = {
					encContentss: response.data.data,
					tickets: response.data.ticket,
					msg: response.data.msg
				}
				QuantumDecrypt(dataReq, successCallback)
			} else { //不需要解密正常返回
				//大于600跳登录
				if ((response.data.code < 700 && response.data.code > 600) || response.data.code === 600) {
					//清除定时器拆章
					bus.$emit('checkOut');
					Message.warning(response.data.msg)
					localStorage.removeItem('userInfo')
					// 在即将进入新的页面组件前，关闭掉进度条
					NProgress.done()
					if (response.data.code == 601) {
						router.replace({
							path: `/${response.data.data.domain}/login`
						})
						return
					}
					router.replace({
						name: 'login',
						path: '/' + store.state.user.roterOrgId + '/login'
					})
				}
				if (response.data.code !== 200) {
					Message.warning(response.data.msg)
				}
				if (response.data.code === 599) {
					router.push({
						name: 'myInfo',
						path: '/' + store.state.user.roterOrgId + '/myInfo'
					})
				}
				// 响应成功回调
				successCallback && successCallback(response.data);
			}

		}, function (error) {
			// 在即将进入新的页面组件前，关闭掉进度条
			NProgress.done()
		});
	}
}
/**
 * @param {String} method - 请求方法get/post
 * @param {String} url
 * @param {String} paramsKey - 请求参数名
 * @param {String} paramsValue - 请求参数值
 */
function doDowload(method, url, paramsKey, paramsValue) {
	const form = document.createElement('form');
	form.style.display = 'none';
	form.setAttribute('target', '_blank');
	form.setAttribute('method', method);
	form.setAttribute('action', url);
	form.setAttribute('_tenant', store.state.user.roterOrgId);
	// form.setAttribute('enctype', "application/json");
	const input = document.createElement('input');
	input.setAttribute('type', 'hidden');
	// 对于get请求 最终会拼成http://xxxx/xxx?name=HAP.pdf
	input.setAttribute('name', paramsKey);
	input.setAttribute('value', paramsValue);
	form.appendChild(input);
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
}
/**
 * @param {String} url
 */
function doBlob(url, req, successCallback) {
	Vue.http.get(service_url + url, {
		params: {
			_tenant: store.state.user.roterOrgId
		},
		responseType: req.responseType
	}).then(response => {
		successCallback && successCallback(response)
	}, blob => {
		console.log(blob);
	});
}

const $lizhao = {
	test: test,
	RSA: RSA,
	guid: guid,
	timeFormat: timeFormat,
	timeFrom: timeFrom,
	deidentification,
	trim,
	debounce,
	gdQSS,
	gkQSS,
	seeImage,
	throttle,
	file,
	ui,
	base64,
	doDowload,
	stringFindDiff,
	createLine,
	clearLine,
	imgUtl,
	getDay,
	url: lzurl,
	bookmark,
	wps,
	str

}
Vue.prototype.$lizhao = $lizhao


export default {
	doGet: doGet,
	doPost: doPost,
	doDelete: doDelete,
	getBeforeDate: getBeforeDate,
	service_Img: service_Img,
	service_url: service_url,
	restrictFormatUploaded: restrictFormatUploaded,
	oosPutObject: oosPutObject,
	oosGetObject: oosGetObject,
	startApp: startApp,
	doUpload,
	doDowload,
	doBlob
}



// WEBPACK FOOTER //
// ./static/js/config/Global.js